module.exports = __webpack_public_path__ + "img/flyhj.a9dc1753.png";